export { KernelEIP1193Provider } from "./KernelEIP1193Provider.js"
